<template>
  <NoticeCard
    :class="b()"
  >
    <el-row
      type="flex"
      align="middle"
    >
      <div
        v-if="data.status !== 1"
        :class="b('uploading')"
      >
        <SymbolIcon
          icon="icondengdai"
          :size="30"
        />
        <div>
          <div :class="b('tips-title')">
            {{ $t('notice.dataProcessing') }}
          </div>
          <div :class="b('upload-tips-dec')">
            {{ $t('notice.other') }}
          </div>
          <el-progress
            :show-text="false"
            :stroke-width="4"
            :percentage="progressNum"
            style="margin-bottom: 12px;"
          >
          </el-progress>
        </div>
      </div>

      <div
        v-if="data.status === 1"
        :class="b('complete-have-fail')"
      >
        <div :class="b('tips-complete')">
          <SymbolIcon
            icon="iconchenggong1"
            :size="30"
          />
          <div :class="b('tips-complete-text')">
            <div :class="b('tips-title')">
              {{ $t('notice.importComplete') }}
            </div>
          </div>
        </div>
      </div>
    </el-row>
    <el-row
      type="flex"
      align="bottom"
      justify="end"
    >
      <div v-if="data.status === 1">
        <el-button
          :class="b('action-submit')"
          type="primary"
          size="mini"
          @click="handleSubmit"
        >
          {{ $t('notice.yes') }}
        </el-button>
      </div>
    </el-row>
  </NoticeCard>
</template>
<script>
import theme from '@zk/theme/lib/variables.scss';
import NoticeCard from '@/components/notice/NoticeCard';
import { getLDAPImportStatus } from '@/api/message';
import { debounce } from 'lodash';

export default {
  name: 'LightweightMembersNoticeCard',
  components: {
    NoticeCard
  },
  props: {
    id: {
      type: String,
      required: true
    },
    isProjectSettingPage: {
      type: Boolean,
      default: false
    }
  },
  bemNS: theme.bemNS,
  data() {
    return {
      startTimer: '',
      data: {
        status: 0
      },
      MAX_TIME: 60
    };
  },
  computed: {
    progressNum() {
      return 0;
    },
    status() {
      return this.data?.status;
    }
  },
  watch: {
    data: {
      handler(value) {
        this.$parent.showClose = value.status === 1;
        if (value && value.status === 1) {
          this.eventBus.$emit('project:member-change');
          this.eventBus.$emit('member-list-change');
        }
      },
      immediate: true
    }
  },
  created() {
    this.load();
    this.time();
  },
  destroyed() {
    clearTimeout(this.startTimer);
  },
  methods: {
    time() {
      this.startTimer = setTimeout(async() => {
        if (this.data.status !== 1) {
          await this.load();
          this.time();
        }
        this.MAX_TIME--;
        console.log(this.MAX_TIME, 'max');
      }, 1000);
    },
    load: debounce(async function() {
      const res = await getLDAPImportStatus(this.id);
      this.data.status = res;
      if (this.MAX_TIME < 1) {
        clearTimeout(this.startTimer);
      }
    }, 500),
    handleClose() {
      this.$parent.close();
    },
    async handleSubmit() {
      this.handleClose();
    }
  }
};
</script>

<style lang="scss">
@include b(lightweight-members-notice-card) {
  svg {
    margin-right:  var(--m-small);
    flex-shrink: 0;
  }
  .zk-lightweight-members-notice-card__uploading {
    display: flex;
    .zk-lightweight-members-notice-card__upload-tips-dec {
      font-weight: var(--weight-font-Regular);
      color: var(--font-color-2);
      margin: 4px 0 12px 0;
    }
  }
  .zk-lightweight-members-notice-card__tips-dec {
    font-weight: var(--weight-font-Regular);
    color: var(--font-color-1);
    margin: 4px 0 12px 0;
  }
  .zk-lightweight-members-notice-card__tips-title {
    font-size: var(--size-font-6);
    font-weight: var(--notice-card-title-weight);
    color: var(--font-color-1);
    line-height: 24px;
  }
  .zk-lightweight-members-notice-card__tips-complete {
    display: flex;
    .zk-lightweight-members-notice-card__tips-num {
      font-weight: var(--weight-font-Regular);
      margin: 4px 0 12px 0;
      .zk-lightweight-members-notice-card__tips-info {
        width: 100%;
        word-break: break-word;
      }
    }
  }
  &:before {
    background-color: var(--main-bg-color);
  }
  .zk-lightweight-members-notice-card__action-submit {
    margin-left: 12px;
  }
  .el-row--flex.is-align-bottom {
    justify-content: flex-end;
  }
}
</style>
